module.exports = __webpack_public_path__ + "img/1.b29f8556.png";